import { Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './components/layout/AppLayout';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import Login from './pages/Login';
import Onboarding from './pages/Onboarding';
import PendingApproval from './pages/PendingApproval';
import Dashboard from './pages/Dashboard';
import TrainingHome from './pages/TrainingHome';
import TrainingModule from './pages/TrainingModule';
import AiAssistant from './pages/AiAssistant';
import JobTracker from './pages/JobTracker';
import JobDetail from './pages/JobDetail';
import InterviewFeedback from './pages/InterviewFeedback';
import CvOptimizer from './pages/CvOptimizer';
import Sessions from './pages/Sessions';
import AlgorithmList from './pages/AlgorithmList';
import AlgorithmProblem from './pages/AlgorithmProblem';
import SystemDesignInterview from './pages/SystemDesignInterview';
import Contacts from './pages/Contacts';
import Settings from './pages/Settings';
import NotFound from './pages/NotFound';
import AdminOverview from './pages/admin/AdminOverview';
import AdminStudentList from './pages/admin/AdminStudentList';
import AdminStudentDetail from './pages/admin/AdminStudentDetail';
import AdminAchievements from './pages/admin/AdminAchievements';
import AdminTrainingDetail from './pages/admin/AdminTrainingDetail';
import AdminLessonEdit from './pages/admin/AdminLessonEdit';
import AdminTrainings from './pages/admin/AdminTrainings';
import Achievements from './pages/Achievements';
import FundamentalsDetail from './pages/FundamentalsDetail';
import { AdminRoute } from './components/AdminRoute';

function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
      <Route path="/pending" element={<ProtectedRoute><PendingApproval /></ProtectedRoute>} />

      {/* Protected — wrapped in ProtectedRoute + AppLayout */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <AppLayout>
              <Dashboard />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/training"
        element={
          <ProtectedRoute>
            <AppLayout>
              <TrainingHome />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/training/modules/:trainingId"
        element={
          <ProtectedRoute>
            <AppLayout>
              <TrainingModule />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/training/modules/:trainingId/lessons/:lessonId"
        element={
          <ProtectedRoute>
            <AppLayout>
              <TrainingModule />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/training/algorithms"
        element={
          <ProtectedRoute>
            <AppLayout>
              <AlgorithmList />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/training/algorithms/:slug"
        element={
          <ProtectedRoute>
            <AppLayout>
              <AlgorithmProblem />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/assistant"
        element={
          <ProtectedRoute>
            <AppLayout>
              <AiAssistant />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/jobs"
        element={
          <ProtectedRoute>
            <AppLayout>
              <JobTracker />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/jobs/:id"
        element={
          <ProtectedRoute>
            <AppLayout>
              <JobDetail />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/jobs/:id/interviews/:interviewId"
        element={
          <ProtectedRoute>
            <AppLayout>
              <InterviewFeedback />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/cv"
        element={
          <ProtectedRoute>
            <AppLayout>
              <CvOptimizer />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sessions"
        element={
          <ProtectedRoute>
            <AppLayout>
              <Sessions />
            </AppLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/training/system-design/:type"
        element={
          <ProtectedRoute>
            <AppLayout>
              <SystemDesignInterview />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/training/fundamentals/:slug"
        element={
          <ProtectedRoute>
            <AppLayout>
              <FundamentalsDetail />
            </AppLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/contacts"
        element={
          <AppLayout>
            <Contacts />
          </AppLayout>
        }
      />

      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <AppLayout>
              <Settings />
            </AppLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/achievements"
        element={
          <ProtectedRoute>
            <AppLayout>
              <Achievements />
            </AppLayout>
          </ProtectedRoute>
        }
      />

      {/* Admin — ADMIN role only */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AppLayout>
                <AdminOverview />
              </AppLayout>
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/students"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AppLayout>
                <AdminStudentList />
              </AppLayout>
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/students/:id"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AppLayout>
                <AdminStudentDetail />
              </AppLayout>
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/achievements"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AppLayout>
                <AdminAchievements />
              </AppLayout>
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/trainings"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AppLayout>
                <AdminTrainings />
              </AppLayout>
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/trainings/:id"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AppLayout>
                <AdminTrainingDetail />
              </AppLayout>
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/trainings/:id/lessons/:lessonId"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AppLayout>
                <AdminLessonEdit />
              </AppLayout>
            </AdminRoute>
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
